import { LearningHistoryRange } from "./learningHistoryRange";

export default class LearningHistory {
  correctTermsCount: number;
  incorrectTermsCount: number;
  goalCount: number;
  range: LearningHistoryRange = LearningHistoryRange.day;

  constructor(
    correctTermsCount: number,
    incorrectTermsCount: number,
    goalCount: number
  ) {
    this.correctTermsCount = correctTermsCount;
    this.incorrectTermsCount = incorrectTermsCount;
    this.goalCount = goalCount;
  }

  static fromJson(json: any): LearningHistory {
    return new LearningHistory(
      json.correctTermsCount,
      json.incorrectTermsCount,
      json.goalCount
    );
  }

  static getEmpty(): LearningHistory {
    return new LearningHistory(-1, -1, -1);
  }
}
